export const config = {
  title: "Diaz Wireless LLC | Comprehensive Security and Smart Home Solutions in El Paso, TX",
  meta: {
    description:
      "Diaz Wireless LLC offers expert security and smart home services in El Paso, TX, including security camera installations, smart home integration, and security lighting.",
    keywords: [
      'Security Services El Paso',
      'Smart Home Integration',
      'Security Camera Installation',
      'Security Lighting',
      'Video Doorbell Installation',
      'Smart Thermostats',
      'Smart Locks',
      'Home Automation El Paso',
      'Diaz Wireless LLC',
      'Veteran-Owned Security Company',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: "Diaz Wireless LLC",
    canonicalUrl: 'https://www.diazwirelessllc.com/',
  },
  sections: {
    header: {
      businessName: "Diaz Wireless LLC",
    },
    sectionB: {
      heroTitle: "Diaz Wireless LLC",
      heroSubtitle: 'Comprehensive Security and Smart Home Solutions in El Paso, TX',
      learnAboutText: 'Explore Our Services',
      phoneNumber: '+19152774406',
      phoneLabel: '(915) 277-4406',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1977230951/photo/cctv-camera-installed-on-wall-of-the-building-scan-the-area-for-surveillance-purposes-can-be.jpg?s=612x612&w=0&k=20&c=f-Nw4cMVtYRU5Wo5D_625XfSU694lt-pSMx35RtyeiI=',
      cardData: [
        {
          title: 'Mission',
          description:
            'At Diaz Wireless LLC, our mission is to provide top-tier security and smart home solutions, ensuring the safety and convenience of our clients through innovative technology and expert installation.',
        },
        {
          title: 'Vision',
          description:
            'To be the leading provider of security and smart home services in El Paso, recognized for our commitment to quality, customer satisfaction, and technological advancement.',
        },
        {
          title: 'Why Choose Us',
          description:
            'With over 10 years of experience, our veteran-owned, family-operated business offers personalized solutions, professional installations, and exceptional customer service to meet your unique security and smart home needs.',
        },
      ],
      description:
        "Diaz Wireless LLC specializes in security camera installations, smart home integration, security lighting, and more. Our team is dedicated to enhancing the safety and functionality of your home or business with customized solutions.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "Discover our range of professional security and smart home services designed to protect and enhance your property.",
      cards: [
        {
          title: 'Security Lighting',
          description:
            "Illuminate your property with our professionally installed security lighting solutions, deterring intruders and enhancing safety.",
          imageSrc:
            'https://lirp.cdn-website.com/md/pexels/dms3rep/multi/opt/pexels-photo-4059469-1920w.jpeg',
          imageAlt: 'Security Lighting'
        },
        {
          title: 'Security Systems Installation',
          description:
            "Protect your property with our expert security camera and alarm system installations, offering real-time monitoring and total security control.",
          imageSrc:
            'https://lirp.cdn-website.com/b99aaf13/dms3rep/multi/opt/Security+Systems+Installation+1-1920w.jpeg',
          imageAlt: 'Security Systems Installation',
        },
        {
          title: 'Smart Home Integration',
          description:
            "Upgrade your living space with our smart home integration services, allowing seamless control of your devices for enhanced convenience and efficiency.",
          imageSrc:
            'https://lirp.cdn-website.com/b99aaf13/dms3rep/multi/opt/5847afd0-e006-43a1-bda0-c5fce9cf9199-a82cea14-1920w.jpg',
          imageAlt: 'Smart Home Integration',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Video Doorbell Installation',
        'Smart Home Systems',
        'Smart Thermostats',
        'Smart Home Devices',
        'Smart Home Controls',
        'Smart Locks',
        'Smart Garage Door Controls',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src:
          'https://media.istockphoto.com/id/1200998021/photo/black-cctv-outside-building-home-security-system.jpg?s=612x612&w=0&k=20&c=19Yn-bpivNZI8G0cSrMi3CCCgSX0OpAjcWDPRb93m3I=',
        alt: "Diaz Wireless LLC Team",
      },
      aboutText: [
        "Founded over a decade ago, Diaz Wireless LLC is a veteran-owned, family-operated business committed to providing reliable security and smart home solutions in El Paso, TX. Our experienced team tailors services to meet the unique needs of each client, ensuring top-quality installations and customer satisfaction.",
        "We pride ourselves on staying abreast of the latest technological advancements to offer innovative solutions that enhance the safety and convenience of your home or business.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Diaz Wireless LLC",
      businessName: "Diaz Wireless LLC",
      contact: {
        phone: '+19152774406',
        phoneLabel: '(915) 277-4406',
        email: 'mario.f.diaz94@outlook.com',
        website: 'https://www.diazwirelessllc.com/',
        address: 'El Paso, TX',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'El Paso, TX',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13457.123456789012!2d-106.486931!3d31.761878!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86e7591234567890%3A0xabcdef1234567890!2sEl%20Paso%2C%20TX!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
